"use client";

import { Check, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheServiceMenu() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const buffetTiers = [{
    name: "Maquillaje",
    description: "Artistry de alta definición para fotografía y cine profesional.",
    price: "€60",
    unit: "",
    featured: false,
    ribbon: "",
    buttonLabel: "Reservar Ahora",
    buttonVariant: "outline" as const,
    inclusions: "Base, contorno, maquillaje de ojos, color de labios"
  }, {
    name: "Cabello y Maquillaje",
    description: "Nuestra transformación más solicitada lista para la alfombra roja.",
    price: "€80",
    unit: "",
    featured: false,
    ribbon: "",
    buttonLabel: "Reservar Ahora",
    buttonVariant: "outline" as const,
    inclusions: "Peinado, base, maquillaje de ojos, color de labios"
  }, {
    name: "Sesión Fotográfica",
    description: "Belleza de vanguardia para proyectos artísticos y de moda.",
    price: "Depende por las horas",
    unit: "",
    featured: false,
    ribbon: "",
    buttonLabel: "Reservar Ahora",
    buttonVariant: "outline" as const,
    inclusions: "Configuración de iluminación, guía de poses, retoque de maquillaje, estilismo de vestuario"
  }, {
    name: "Novia",
    description: "Consulta detallada para perfeccionar tu look del día de la boda.",
    price: "€150",
    unit: "",
    featured: false,
    ribbon: "",
    buttonLabel: "Reservar Ahora",
    buttonVariant: "outline" as const,
    inclusions: "Sesión de prueba, estilismo de velo, prueba de maquillaje, retoque in situ"
  }, {
    name: "Tutorial de Maquillaje",
    description: "Coaching profesional de técnicas uno a uno.",
    price: "€60 para 2 horas",
    unit: "",
    featured: false,
    ribbon: "",
    buttonLabel: "Reservar Ahora",
    buttonVariant: "outline" as const,
    inclusions: "Revisión de kit, demostración de técnicas, práctica práctica, certificado"
  }];
  return <section data-section-id="788" id="the-service-menu" className="relative overflow-hidden bg-background py-32 text-foreground light">
      {}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[500px]" style={{
      background: "linear-gradient(to bottom, hsla(32, 44%, 52%, 0.05) 0%, transparent 100%)"
    }} />

      {}
      <div className="pointer-events-none absolute left-1/2 top-20 -translate-x-1/2 select-none whitespace-nowrap font-serif text-[6rem] font-light tracking-tight text-foreground/[0.04] md:text-[8rem] lg:text-[10rem]">
        Beauty Services
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          <div className="mb-6 flex items-center justify-center gap-3">
            <span className="h-px w-10 bg-primary" />
            <span className="font-mono text-xs font-medium uppercase tracking-[0.25em] text-primary">
              Artistry Profesional
            </span>
            <span className="h-px w-10 bg-primary" />
          </div>

          <h2 className="font-default text-5xl font-light leading-[1.05] tracking-tight text-foreground md:text-6xl lg:text-7xl">
            Diseñado para tu{" "}
            <em className="font-serif italic text-primary">
              visión
            </em>
          </h2>

          <p className="mt-8 font-default text-base leading-relaxed text-muted-foreground md:text-lg">Cada rostro es un lienzo. Elige un servicio distintivo, o colabora conmigo para crear un look completamente tuyo — cada sesión diseñada con dedicación inquebrantable al detalle.</p>
        </div>

        {}
        <div className="mt-16 flex justify-center">
          <Tabs defaultValue="makeup" className="w-full">
            <div className="flex justify-center">
              <TabsList className="h-auto w-full max-w-2xl gap-4 rounded-lg border-b border-border bg-transparent p-0 md:gap-12">
                
                
                
              </TabsList>
            </div>

            {}
            {["makeup", "hair", "bridal"].map((tab, tabIdx) => <TabsContent key={tab} value={tab} className="mt-16" data-index={tabIdx}>
                <div ref={tabIdx === 0 ? cardsRef : undefined} className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 lg:items-start lg:gap-6">
                  {buffetTiers.map((tier, i) => <div key={tier.name} data-index={i} className={`relative flex flex-col rounded-lg border bg-card/40 p-8 transition-all duration-700 backdrop-blur-sm lg:p-10 ${tier.featured ? "border-primary shadow-lg lg:-mt-6 lg:scale-[1.03]" : "border-border shadow-md hover:border-primary/30 hover:shadow-lg"} ${cardsVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
                      {}
                      {tier.ribbon && <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                          <div className="flex items-center gap-1.5 rounded-lg bg-primary px-4 py-1.5 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-primary-foreground shadow-md">
                            <Sparkles className="h-3 w-3" />
                            {tier.ribbon}
                          </div>
                        </div>}

                      {}
                      <h3 className="font-default text-2xl font-light tracking-tight text-foreground">
                        {tier.name}
                      </h3>

                      {}
                      <p className="mt-3 font-serif text-sm italic leading-relaxed text-muted-foreground">
                        {tier.description}
                      </p>

                      {}
                      <div className="mt-6 h-px w-12 bg-primary/40" />

                      {}
                      <div className="mt-6 flex items-baseline gap-1">
                        <span className="font-default text-3xl font-light leading-none text-foreground lg:text-4xl">
                          {tier.price}
                        </span>
                        {tier.unit && <span className="font-default text-xs text-muted-foreground">
                            {tier.unit}
                          </span>}
                      </div>

                      {}
                      <ul className="mt-8 space-y-4">
                        {tier.inclusions.split(', ').map((item, idx) => <li key={idx} data-index={idx} className="flex items-start gap-3 font-default text-xs leading-relaxed text-foreground/70">
                            <span className="mt-1 h-1 w-1 shrink-0 rounded-lg bg-primary/60" />
                            <span>{item}</span>
                          </li>)}
                      </ul>

                      {}
                      <div className="mt-10 pt-2">
                        {tier.buttonVariant === "default" ? <Button asChild size="lg" className="h-12 w-full rounded-lg bg-primary font-default text-sm font-medium tracking-wide text-primary-foreground shadow-md hover:bg-primary/90">
                            <Link to="/BookingPage">
                              {tier.buttonLabel} &rarr;
                            </Link>
                          </Button> : tier.buttonVariant === "gold" ? <Button asChild variant="outline" size="lg" className="h-12 w-full rounded-lg border-2 border-primary bg-transparent font-default text-sm font-medium tracking-wide text-primary shadow-md hover:bg-primary hover:text-primary-foreground">
                            <Link to="/ContactPage">{tier.buttonLabel}</Link>
                          </Button> : <Button asChild variant="outline" size="lg" className="h-12 w-full rounded-lg border border-border bg-background/50 font-default text-sm font-medium tracking-wide text-foreground shadow-md hover:bg-foreground hover:text-background">
                            <Link to="/BookingPage">{tier.buttonLabel}</Link>
                          </Button>}
                      </div>
                    </div>)}
                </div>
              </TabsContent>)}
          </Tabs>
        </div>

        {}
        <div className="mt-20 flex flex-col items-center justify-center gap-4">
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-border" />
            <span className="h-1.5 w-1.5 rounded-lg bg-border" />
            <span className="h-px w-8 bg-border" />
          </div>
          <p className="max-w-2xl text-center font-serif text-base italic leading-relaxed text-muted-foreground md:text-lg">Todas las sesiones incluyen selección de productos de alta calidad y mi toque editorial distintivo.</p>
        </div>
      </div>
    </section>;
}